import gql from 'graphql-tag';

export default gql`
  mutation RequestFeedback($requestId: String!, $feedback: Boolean!) {
    dailyTracker {
      aiRequestFeedback(requestId: $requestId, feedback: $feedback) {
        ... on BasicMutationSuccess {
          code
        }
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
